// setNodeOptions.js
// Этот файл устанавливает переменную окружения для Node.js,
// чтобы использовать устаревший криптографический провайдер.
process.env.NODE_OPTIONS = '--openssl-legacy-provider';
